var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 9.5c.7 0 1.3.6 1.3 1.3 0 .6-.6 1.2-1.3 1.2H1.3C.6 12 0 11.4 0 10.8c0-.7.6-1.3 1.3-1.3zm0-4.8c.7 0 1.3.6 1.3 1.3s-.6 1.3-1.3 1.3H1.3C.6 7.3 0 6.7 0 6s.6-1.3 1.3-1.3zm0-4.7c.7 0 1.3.6 1.3 1.3 0 .6-.6 1.2-1.3 1.2H1.3C.6 2.5 0 1.9 0 1.3 0 .6.6 0 1.3 0z",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--menu-0066d1b5d9c3c5f3324b3f5adf4632d9.svg";
export { SvgIconUiMenu as Component };